import axios from 'axios';

// Бесплатный API ключ (можно получить на openweathermap.org)
// Для теста используем публичный ключ, но лучше получить свой
const API_KEY = 'bd5e378503939ddaee76f12ad7a97608'; // Публичный тестовый ключ
const BASE_URL = 'https://api.openweathermap.org/data/2.5/weather';

export const fetchWeather = async (city) => {
  try {
    const response = await axios.get(BASE_URL, {
      params: {
        q: city,
        appid: API_KEY,
        units: 'metric',
        lang: 'ru'
      }
    });

    const data = response.data;
    
    // Преобразуем данные в удобный формат
    return {
      city: data.name,
      temp: Math.round(data.main.temp),
      feels_like: Math.round(data.main.feels_like),
      humidity: data.main.humidity,
      pressure: data.main.pressure,
      wind: Math.round(data.wind.speed),
      weather: data.weather[0].main,
      description: data.weather[0].description,
      lat: data.coord.lat,
      lon: data.coord.lon
    };
  } catch (error) {
    console.error('Ошибка при получении погоды:', error);
    throw new Error('City not found');
  }
};